module.exports = __webpack_public_path__ + "static/media/menuWorkflow.d6728beb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuWorkflow.svg
// module id = 178
// module chunks = 0